<template>
    <div :class="{ 'px-lg card-half': isHalf }">
        <div class="card">
            <div class="flex justify-between items-center mb-lg">
                <h4 class="card__title">
                    {{ title }}
                </h4>

                <div v-if="$slots.actions" class="card-actions">
                    <slot name="actions" />
                </div>
            </div>

            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                required: true,
                type: String,
            },
            isHalf: {
                required: false,
                type: Boolean,
                default: false,
            },
        },
    };
</script>